import { Event } from '@/app/event-stream';
import { TocItem } from '@/app/shared/models';
import { SectionCompletion } from '@/app/statistics/section/section-progress';

export const SectionInteractedEventName = 'section-interacted' as const;
interface SectionInteractedEvent {
  sectionId?: string;
  interaction?: any;
  scrolledPercent?: number;
  page?: number;
}

export const StatisticsUpdatedEventName = 'statistics-updated' as const;
export interface StatisticsUpdated {
  completion: SectionCompletion;
}

export const SelectedChapterPercentUpdatedEventName = 'selected-chapter-percent-updated' as const;
export interface SelectedChapterPercentUpdated {
  sectionId: string;
  selectedChapter: TocItem;
}

export type SectionInteractionEvent = Event<typeof SectionInteractedEventName, SectionInteractedEvent>
  | Event<typeof StatisticsUpdatedEventName, StatisticsUpdated>
  | Event<typeof SelectedChapterPercentUpdatedEventName, SelectedChapterPercentUpdated>;
